import FJMobileHistory from './FJMobileHistory';
import { useDispatch, useSelector } from 'react-redux';
import useLocalStore from '../../../hooks/useLocalStore';
import FJActionModal from '../../../redux/action/FJActionModal';
import { useCallback } from 'react';
import {
    setSliceIsMobileMultiSelect,
    setSliceIsShowMobileHistory,
    setSliceSelectListAction,
} from '../../../redux/slices/FJSliceCommon';
import FJActionCommon from '../../../redux/action/FJActionCommon';

const FJMobileHistoryContainer = () => {
    useLocalStore();
    const dispatch = useDispatch();

    const historyList = useSelector(state => state.common.historyList);
    const selectList = useSelector(state => state.common.selectList);
    const historyListLoadStatus = useSelector(state => state.common.historyListLoadStatus);
    const isShowMobileHistory = useSelector(state => state.common.isShowMobileHistory);
    const isMobileMultiSelect = useSelector(state => state.common.isMobileMultiSelect);

    const previewImage = data => {
        dispatch(FJActionModal.showPreviewModalDataAction({ data }));
    };

    const setSelectList = useCallback(
        value => {
            dispatch(setSliceSelectListAction(value));
        },
        [dispatch],
    );

    const multiDownload = useCallback(
        (ids, source, callback) => {
            dispatch(FJActionCommon.multiDownloadAction(ids, source, callback));
        },
        [dispatch],
    );

    const multiDelete = useCallback(
        ids => {
            dispatch(FJActionCommon.multiDeleteAction(ids));
        },
        [dispatch],
    );

    const onEdit = useCallback(
        (item, callback) => {
            dispatch(FJActionModal.editHistoryItemAction(item, callback));
        },
        [dispatch],
    );
    const _gotoBack = () => {
        dispatch(setSliceIsShowMobileHistory(false));
        setIsMobileMultiSelect(false);
    };
    const setIsMobileMultiSelect = bool => {
        dispatch(setSliceIsMobileMultiSelect(bool));
    };
    return (
        <FJMobileHistory
            active={isShowMobileHistory}
            list={historyList}
            selectList={selectList}
            historyListLoadStatus={historyListLoadStatus}
            setSelectList={setSelectList}
            previewImage={previewImage}
            onEdit={onEdit}
            gotoBack={_gotoBack}
            isMobileMultiSelect={isMobileMultiSelect}
            setIsMobileMultiSelect={setIsMobileMultiSelect}
            multiDownload={multiDownload}
            multiDelete={multiDelete}
        />
    );
};
export default FJMobileHistoryContainer;
